import React, { type FunctionComponent } from 'react'
import {
  Button,
  Modal,
  ModalBody,
  ModalContainer,
  ModalFooter,
  ModalHeader,
  Text,
} from '@retailer-platform/shared-components'
import { useDomainMessages } from '../../utils/domain/intl'

interface Props {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}

export const QualityAuditWorkflowTombstoneConfirmModal: FunctionComponent<Props> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  const i18n = useDomainMessages({
    title: 'catalogAdminDomain.qualityAuditWorkflows.tombstone.modal.title',
    message: 'catalogAdminDomain.qualityAuditWorkflows.tombstone.modal.message',
    confirm: 'catalogAdminDomain.qualityAuditWorkflows.tombstone.modal.confirm',
    cancel: 'catalogAdminDomain.qualityAuditWorkflows.tombstone.modal.cancel',
  })

  return (
    <Modal maxWidth={'500px'} isOpen={isOpen} hideCloseButton={true}>
      <ModalContainer>
        <ModalHeader>{i18n.title}</ModalHeader>
        <ModalBody>
          <Text>{i18n.message}</Text>
        </ModalBody>
        <ModalFooter>
          <Button variant={'secondary'} onClick={onClose}>
            {i18n.cancel}
          </Button>
          <Button variant={'detrimental'} onClick={onConfirm}>
            {i18n.confirm}
          </Button>
        </ModalFooter>
      </ModalContainer>
    </Modal>
  )
}
